var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"tabindex":_vm.tabindex},on:{"keypress":_vm.onEnter}},[_c('input',{ref:_vm.id,staticClass:"white",attrs:{"disabled":_vm.disabled,"id":_vm.id,"type":"checkbox"},on:{"click":function($event){return _vm.$emit('click', $event.target)}}}),_vm._v(" "),_c('div',{staticClass:"checklist"})])
}
var staticRenderFns = []

export { render, staticRenderFns }